import { useEffect } from "react";
import { useNavigate } from "react-router";
import { ensureMsalInitialized } from "../auth/msalClient";

/**
 * Auth callback page — MSAL processes the redirect response here.
 *
 * `handleRedirectPromise()` (called inside `ensureMsalInitialized`) extracts
 * the auth code from the URL. With `navigateToLoginRequestUrl: true` in the
 * MSAL config, the library automatically navigates back to the page the user
 * was on before sign-in (e.g. `/`, `/edit/…`).
 *
 * If for some reason MSAL doesn't navigate away (e.g. the user hit
 * `/auth/callback` directly), we fall back to `/` after a short delay.
 */
export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    ensureMsalInitialized().then(() => {
      // MSAL's navigateToLoginRequestUrl should have navigated away by now.
      // If we're still here, fall back to the home page.
      timer = setTimeout(() => navigate("/", { replace: true }), 2000);
    });

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
        fontFamily: "system-ui, sans-serif",
        fontSize: 18,
      }}
    >
      Completing sign-in…
    </div>
  );
}
